/**
 * StudentExperienceTrendSparkline — country-aware sparkline wrapper.
 * Renders the right national-survey trend for this uni:
 *   UK → NSS Q26 3-year sparkline (HESA verified)
 *   AU → QILT SES 7-year national + up to 2-year per-uni overlay
 *   other → null
 */
import NssTrendSparkline from "@/components/app/NssTrendSparkline";
import QiltTrendSparkline from "@/components/app/QiltTrendSparkline";

export default function StudentExperienceTrendSparkline({ uni, uniId, country }) {
  const c = country || uni?.country;
  const id = uniId || uni?.id;
  if (!id) return null;
  if (c === "UK" || c === "United Kingdom") return <NssTrendSparkline uniId={id} />;
  if (c === "AU" || c === "Australia") return <QiltTrendSparkline uniId={id} />;
  return null;
}
